// Local-only state: language preference + owner profile prefill (UX, no PII to server).

export type Lang = 'ro' | 'en';

export interface OwnerProfile {
  dog_name: string;
  dog_breed: string;
  dog_age_range: string;
  dog_size: string;
  dog_gender: string;
  dog_city: string;
  dog_superpower: string;
  dog_hobby: string;
  owner_name: string;
  instagram_handle: string;
  email: string;
  phone: string;
}

const KEY_PROFILE = 'sniff-quest-profile';
const KEY_LANG = 'sq-lang';

export function getLang(): Lang {
  const v = localStorage.getItem(KEY_LANG);
  return v === 'en' ? 'en' : 'ro';
}
export function setLang(l: Lang) { localStorage.setItem(KEY_LANG, l); }

export function getProfile(): Partial<OwnerProfile> {
  const raw = localStorage.getItem(KEY_PROFILE);
  if (!raw) return {};
  try { return JSON.parse(raw); } catch { return {}; }
}
export function saveProfile(p: OwnerProfile) { localStorage.setItem(KEY_PROFILE, JSON.stringify(p)); }
export function clearProfile() { localStorage.removeItem(KEY_PROFILE); }
